import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  listar(params: { leida?: 0 | 1; origen_tipo?: string; per_page?: number; page?: number } = {}) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.token
    });

    const query: string[] = [];
    if (params.leida !== undefined) query.push('leida=' + params.leida);
    if (params.origen_tipo) query.push('origen_tipo=' + encodeURIComponent(params.origen_tipo));
    if (params.per_page) query.push('per_page=' + params.per_page);
    if (params.page) query.push('page=' + params.page);

    const url = URL_SERVICIOS + '/notificaciones' + (query.length ? '?' + query.join('&') : '');

    return this.http.get(url, { headers });
  }

  unreadCount() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.token
    });

    return this.http.get(URL_SERVICIOS + '/notificaciones/unread-count', { headers });
  }

  marcarLeida(id: number) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.token
    });

    return this.http.post(URL_SERVICIOS + '/notificaciones/' + id + '/marcar-leida', {}, { headers });
  }

  marcarTodasLeidas() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.token
    });

    return this.http.post(URL_SERVICIOS + '/notificaciones/marcar-todas-leidas', {}, { headers });
  }

  borrarTodas() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.token
    });

    return this.http.post(URL_SERVICIOS + '/notificaciones/borrar-todas', {}, { headers });
  }
}